import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";

/** Ссылка «← раздел» над страницей (страницы держали её копией, различались только адрес и подпись). */
export function BackLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link to={to} className="inline-flex w-fit items-center gap-1 text-[12.5px] text-fg-muted hover:text-fg">
      <ArrowLeft size={13} />
      {children}
    </Link>
  );
}
